import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/168/components/features/cases/OldComponents/cases/gens/index.js");
